/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

export const course = (state) => state.course
export const userInfo = (state) => state.userInfo
export const productGuid = (state) => state.productGuid
export const userGuid = (state) => state.userGuid
export const thirdParty = (state) => state.thirdParty
export const thirdPartyInfo = (state) => state.thirdPartyInfo
export const beforeLoginPage = (state) => state.beforeLoginPage
export const systemInfo = (state) => state.systemInfo
export const authorToken = (state) => state.authorToken
export const orderInfo = (state) => state.orderInfo
export const orderInquireState = (state) => state.orderInquireState
export const orderVTime = (state) => state.orderVTime
export const bannerState = (state) => state.bannerState
export const backgoFile = (state) => state.backgoFile




// WEBPACK FOOTER //
// ./src/store/getter.js